import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MentorService } from 'src/app/mentor/services/mentors.service';
import { MentorAuthService } from 'src/app/mentor/services/mentor-auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'app-view-feedback',
  templateUrl: './view-feedback.component.html',
  styleUrls: ['./view-feedback.component.css']
})
export class ViewFeedbackComponent implements OnInit {
  @ViewChild('form') form: NgForm
  scholars: any = []
  feedbackModel: any = {};
  id: any
  constructor(private mentorService: MentorService, private activatedRoute: ActivatedRoute,private router:Router,private location: Location ) {
    this.id = this.activatedRoute.snapshot.params['id']
  }
  ngOnInit() {
    this.getFeedbackById()
    this.feedbackModel.interactionFocus=[]

  }
  getFeedbackById() {
    this.mentorService.getFeedbackById(this.id).subscribe((res) => {
      this.feedbackModel = res;
    })
  }
  minDate() {
    return new Date()
  }
  getAssignedScholars() {
    this.mentorService.getAssignedScholars().subscribe((res) => {
      this.scholars = res
    })
  }
  back(){
    if(this.router.url.includes('/mentor/view-feedback')){
      // this.router.navigate(['mentor'])
      this.location.back();
    }else{
      // this.router.navigate(['co-ordinator/assign'])
      this.location.back();
    }
    
  }
  isChecked(value){
    for(let i=0;i<this.feedbackModel.interactionFocus.length;i++)
      if(this.feedbackModel.interactionFocus[i]==value)
        return true
    return false
  }

}

